<template>
  <div class="release-note-container">
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="版本号">
          <el-input
            v-model="searchForm.versionNo"
            placeholder="请输入版本号"
            clearable
            @keyup.enter.native="handleSearch"
            style="width: 180px"
          ></el-input>
        </el-form-item>

        <el-form-item label="发版时间">
          <el-date-picker
            v-model="releaseTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 320px"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="发版类型">
          <el-select
            v-model="searchForm.releaseType"
            placeholder="请选择"
            clearable
            style="width: 140px"
          >
            <el-option v-for="item in releaseTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

<!--        <el-form-item label="版本状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择"
            clearable
            style="width: 140px"
          >
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>-->

        <el-form-item label="是否展示">
          <el-select
            v-model="searchForm.isShow"
            placeholder="请选择"
            clearable
            style="width: 120px"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="handleAdd"
            v-permission="'releaseNote:add'"
          >新增发版日志</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card">
      <el-table
        :data="releaseNoteList"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>

        <el-table-column prop="versionNo" label="版本号" width="120" align="center"></el-table-column>

        <el-table-column prop="title" label="版本标题" min-width="120"  align="center"></el-table-column>

        <el-table-column prop="releaseTime" label="发版时间" width="160" align="center"></el-table-column>

        <el-table-column label="发版类型" width="110" align="center">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="releaseTypeTagType(scope.row.releaseType)"
            >{{ releaseTypeText(scope.row.releaseType) }}</el-tag>
          </template>
        </el-table-column>

<!--        <el-table-column label="版本状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="statusTagType(scope.row.status)"
            >{{ statusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>-->

        <el-table-column label="是否展示" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="scope.row.isShow === 1 ? 'success' : 'info'"
            >{{ scope.row.isShow === 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="弹窗推送" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              size="small"
              :type="scope.row.isPush === 1 ? 'warning' : 'info'"
            >{{ scope.row.isPush === 1 ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="createBy" label="创建人" width="100" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" width="100" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="300" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-view"
              @click="handleDetail(scope.row)"
            >详情</el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              v-permission="'releaseNote:update'"
            >编辑</el-button>
<!--            <el-button
              v-if="scope.row.status === 1"
              type="warning"
              size="mini"
              icon="el-icon-bottom"
              @click="handlePublish(scope.row, 2)"
              v-permission="'releaseNote:publish'"
            >下线</el-button>
            <el-button
              v-else
              type="success"
              size="mini"
              icon="el-icon-top"
              @click="handlePublish(scope.row, 1)"
              v-permission="'releaseNote:publish'"
            >上线</el-button>-->
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              v-permission="'releaseNote:delete'"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;"
      ></el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="680px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        :model="releaseNoteForm"
        :rules="formRules"
        ref="releaseNoteFormRef"
        label-width="110px"
      >
        <el-form-item label="版本号" prop="versionNo">
          <el-input
            v-model="releaseNoteForm.versionNo"
            placeholder="请输入版本号，如 V1.0.0"
            :disabled="isEdit"
            maxlength="64"
          ></el-input>
          <div class="form-tip" v-if="isEdit">版本号历史固化，不可修改</div>
        </el-form-item>

        <el-form-item label="发版时间" prop="releaseTime">
          <el-date-picker
            v-model="releaseNoteForm.releaseTime"
            type="datetime"
            placeholder="请选择实际发版时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="发版类型" prop="releaseType">
          <el-select v-model="releaseNoteForm.releaseType" placeholder="请选择发版类型" style="width: 100%">
            <el-option v-for="item in releaseTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="版本标题" prop="title">
          <el-input v-model="releaseNoteForm.title" placeholder="请输入版本标题" maxlength="255" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="发版内容" prop="content">
          <el-input
            v-model="releaseNoteForm.content"
            type="textarea"
            :rows="8"
            placeholder="请输入发版详细内容，支持 Markdown 格式（新增、优化、修复、注意事项等）"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否展示" prop="isShow">
          <el-radio-group v-model="releaseNoteForm.isShow">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="form-tip">仅后台内部标记使用，暂无对外展示作用</div>
        </el-form-item>

        <el-form-item label="弹窗推送" prop="isPush">
          <el-radio-group v-model="releaseNoteForm.isPush">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="form-tip">开启后，版本上线内容将通过弹窗提醒所有后台用户</div>
        </el-form-item>

        <el-form-item label="内部备注">
          <el-input
            v-model="releaseNoteForm.remark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="内部备注，仅后台可见"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      title="发版日志详情"
      :visible.sync="detailVisible"
      width="720px"
    >
      <el-descriptions :column="2" border v-if="detailData">
        <el-descriptions-item label="版本号">{{ detailData.versionNo }}</el-descriptions-item>
<!--        <el-descriptions-item label="版本状态">
          <el-tag size="small" :type="statusTagType(detailData.status)">{{ statusText(detailData.status) }}</el-tag>
        </el-descriptions-item>-->
        <el-descriptions-item label="发版时间">{{ detailData.releaseTime }}</el-descriptions-item>
        <el-descriptions-item label="发版类型">{{ releaseTypeText(detailData.releaseType) }}</el-descriptions-item>
        <el-descriptions-item label="是否展示">{{ detailData.isShow === 1 ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="弹窗推送">{{ detailData.isPush === 1 ? '是' : '否' }}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{ detailData.createBy }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createTime }}</el-descriptions-item>
        <el-descriptions-item label="更新人">{{ detailData.updateBy || '-' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.updateTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="内部备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="发版内容" :span="2">
          <div class="detail-content md-body" v-html="detailContentHtml"></div>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { resolveContentHtml } from '../../utils/rich-text'

export default {
  name: 'ReleaseNote',
  data() {
    return {
      // 搜索表单
      searchForm: {
        versionNo: '',
        releaseType: null,
        status: null,
        isShow: null,
        releaseTimeStart: '',
        releaseTimeEnd: ''
      },
      releaseTimeRange: [],

      // 字典
      releaseTypeOptions: [
        { label: '功能迭代', value: 1 },
        { label: 'Bug修复', value: 2 },
        { label: '紧急热更', value: 3 },
        { label: '配置变更', value: 4 }
      ],
      statusOptions: [
        { label: '草稿', value: 0 },
        { label: '已上线', value: 1 },
        { label: '已下线', value: 2 }
      ],

      // 列表
      releaseNoteList: [],
      loading: false,

      // 分页
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: 0
      },

      // 新增/编辑对话框
      dialogVisible: false,
      dialogTitle: '新增发版日志',
      isEdit: false,
      submitLoading: false,

      // 表单
      releaseNoteForm: {
        id: null,
        versionNo: '',
        releaseTime: '',
        releaseType: 1,
        title: '',
        content: '',
        isShow: 1,
        isPush: 0,
        remark: ''
      },

      // 表单校验规则
      formRules: {
        versionNo: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        releaseTime: [
          { required: true, message: '请选择发版时间', trigger: 'change' }
        ],
        releaseType: [
          { required: true, message: '请选择发版类型', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入版本标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入发版内容', trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: '请选择是否展示', trigger: 'change' }
        ],
        isPush: [
          { required: true, message: '请选择是否弹窗推送', trigger: 'change' }
        ]
      },

      // 详情对话框
      detailVisible: false,
      detailData: null
    };
  },

  computed: {
    // 发版内容：后端 contentHtml 优先（Markdown 已在后端转 HTML），旧接口兜底转义原文
    detailContentHtml() {
      return resolveContentHtml(this.detailData)
    }
  },

  mounted() {
    this.loadReleaseNoteList();
  },

  methods: {
    // 加载列表
    async loadReleaseNoteList() {
      this.loading = true;
      try {
        const params = {
          versionNo: this.searchForm.versionNo,
          releaseType: this.searchForm.releaseType,
          status: this.searchForm.status,
          isShow: this.searchForm.isShow,
          releaseTimeStart: this.searchForm.releaseTimeStart,
          releaseTimeEnd: this.searchForm.releaseTimeEnd,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };

        const { data: res } = await this.$http.post('release-note/page', params);

        if (res.status === 0) {
          this.releaseNoteList = res.list || [];
          this.pagination.total = res.totalCount || 0;
        } else {
          this.$message.error(res.msg || '加载失败');
        }
      } catch (error) {
        console.error('加载发版日志列表失败', error);
        this.$message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      if (this.releaseTimeRange && this.releaseTimeRange.length === 2) {
        this.searchForm.releaseTimeStart = this.releaseTimeRange[0];
        // daterange 选择的结束日期时间为 00:00:00，这里强制补齐到当天 23:59:59，避免漏查当天数据
        this.searchForm.releaseTimeEnd = this.releaseTimeRange[1]
          ? this.releaseTimeRange[1].replace(/\d{2}:\d{2}:\d{2}$/, '23:59:59')
          : '';
      } else {
        this.searchForm.releaseTimeStart = '';
        this.searchForm.releaseTimeEnd = '';
      }
      this.pagination.pageNum = 0;
      this.loadReleaseNoteList();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        versionNo: '',
        releaseType: null,
        status: null,
        isShow: null,
        releaseTimeStart: '',
        releaseTimeEnd: ''
      };
      this.releaseTimeRange = [];
      this.pagination.pageNum = 0;
      this.loadReleaseNoteList();
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 0;
      this.loadReleaseNoteList();
    },

    handleCurrentChange(val) {
      this.pagination.pageNum = val - 1;
      this.loadReleaseNoteList();
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增发版日志';
      this.isEdit = false;
      this.dialogVisible = true;
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑发版日志';
      this.isEdit = true;
      this.releaseNoteForm = {
        id: row.id,
        versionNo: row.versionNo,
        releaseTime: row.releaseTime,
        releaseType: row.releaseType,
        title: row.title,
        content: row.content || '',
        isShow: row.isShow,
        isPush: row.isPush === 0 ? 0 : (row.isPush || 0),
        remark: row.remark || ''
      };
      this.dialogVisible = true;
    },

    // 详情
    async handleDetail(row) {
      this.detailData = null;
      this.detailVisible = true;
      try {
        const { data: res } = await this.$http.get('release-note/detail', { params: { id: row.id } });
        if (res.status === 0) {
          this.detailData = res.data || row;
        } else {
          this.$message.error(res.msg || '查询详情失败');
          this.detailData = row;
        }
      } catch (error) {
        console.error('查询详情失败', error);
        this.detailData = row;
      }
    },

    // 上线/下线
    handlePublish(row, status) {
      const actionText = status === 1 ? '上线' : '下线';
      this.$confirm(`确定要${actionText}版本【${row.versionNo}】吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.get('release-note/publish/' + row.id, { params: { status } });

          if (res.status === 0) {
            this.$message.success(`${actionText}成功`);
            this.loadReleaseNoteList();
          } else {
            this.$message.error(res.msg || `${actionText}失败`);
          }
        } catch (error) {
          console.error(`${actionText}失败`, error);
          this.$message.error(`${actionText}失败`);
        }
      }).catch(() => {});
    },

    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除版本【${row.versionNo}】吗？删除后仅可通过数据库查询历史数据。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data: res } = await this.$http.get('release-note/delete/' + row.id);

          if (res.status === 0) {
            this.$message.success('删除成功');
            this.loadReleaseNoteList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败', error);
          this.$message.error('删除失败');
        }
      }).catch(() => {});
    },

    // 提交表单
    handleSubmit() {
      this.$refs.releaseNoteFormRef.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        this.submitLoading = true;
        try {
          if (this.isEdit) {
            const { data: res } = await this.$http.post('release-note/update', this.releaseNoteForm);
            if (res.status === 0) {
              this.$message.success('更新成功');
              this.dialogVisible = false;
              this.loadReleaseNoteList();
            } else {
              this.$message.error(res.msg || '更新失败');
            }
          } else {
            const { data: res } = await this.$http.post('release-note/add', this.releaseNoteForm);
            if (res.status === 0) {
              this.$message.success('添加成功');
              this.dialogVisible = false;
              this.loadReleaseNoteList();
            } else {
              this.$message.error(res.msg || '添加失败');
            }
          }
        } catch (error) {
          console.error('提交失败', error);
          this.$message.error('操作失败');
        } finally {
          this.submitLoading = false;
        }
      });
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.releaseNoteFormRef.resetFields();
      this.releaseNoteForm = {
        id: null,
        versionNo: '',
        releaseTime: '',
        releaseType: 1,
        title: '',
        content: '',
        isShow: 1,
        isPush: 0,
        remark: ''
      };
    },

    // 字典辅助
    releaseTypeText(val) {
      const item = this.releaseTypeOptions.find(o => o.value === val);
      return item ? item.label : '-';
    },
    releaseTypeTagType(val) {
      const map = { 1: '', 2: 'warning', 3: 'danger', 4: 'info' };
      return map[val] || '';
    },
    statusText(val) {
      const item = this.statusOptions.find(o => o.value === val);
      return item ? item.label : '-';
    },
    statusTagType(val) {
      const map = { 0: 'info', 1: 'success', 2: 'danger' };
      return map[val] || 'info';
    }
  }
};
</script>

<style scoped>
.release-note-container {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.table-card {
  margin-top: 20px;
}

.form-tip {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  margin-top: 4px;
}

.detail-content {
  white-space: pre-wrap;
  word-break: break-word;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 12px;
  max-height: 320px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.8;
}

/* 发版内容（Markdown 转 HTML 后由 v-html 渲染，v-html 内容需用深度选择器） */
.detail-content.md-body ::v-deep p {
  margin: 0 0 8px;
}

.detail-content.md-body ::v-deep p:last-child {
  margin-bottom: 0;
}

.detail-content.md-body ::v-deep h1,
.detail-content.md-body ::v-deep h2,
.detail-content.md-body ::v-deep h3,
.detail-content.md-body ::v-deep h4,
.detail-content.md-body ::v-deep h5,
.detail-content.md-body ::v-deep h6 {
  margin: 12px 0 8px;
  font-weight: 600;
  line-height: 1.4;
}

.detail-content.md-body ::v-deep h1 {
  font-size: 18px;
}

.detail-content.md-body ::v-deep h2 {
  font-size: 16px;
}

.detail-content.md-body ::v-deep h3,
.detail-content.md-body ::v-deep h4,
.detail-content.md-body ::v-deep h5,
.detail-content.md-body ::v-deep h6 {
  font-size: 14px;
}

.detail-content.md-body ::v-deep ul,
.detail-content.md-body ::v-deep ol {
  margin: 0 0 8px;
  padding-left: 22px;
}

.detail-content.md-body ::v-deep li {
  margin: 2px 0;
}

.detail-content.md-body ::v-deep blockquote {
  margin: 0 0 8px;
  padding: 6px 12px;
  border-left: 4px solid #dcdfe6;
  background: #fff;
  color: #606266;
}

.detail-content.md-body ::v-deep code {
  padding: 1px 5px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 3px;
  font-family: Consolas, Monaco, monospace;
}

.detail-content.md-body ::v-deep pre {
  margin: 0 0 8px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow-x: auto;
}

.detail-content.md-body ::v-deep pre code {
  padding: 0;
  border: none;
  background: transparent;
}

.detail-content.md-body ::v-deep a {
  color: #409eff;
}

.detail-content.md-body ::v-deep img {
  max-width: 100%;
}

.detail-content.md-body ::v-deep hr {
  border: none;
  border-top: 1px solid #e4e7ed;
  margin: 12px 0;
}
</style>
